import { render, staticRenderFns } from "./vuetiform-info.vue?vue&type=template&id=3768b02f&scoped=true&"
import script from "./vuetiform-info.vue?vue&type=script&lang=js&"
export * from "./vuetiform-info.vue?vue&type=script&lang=js&"
import style0 from "./vuetiform-info.vue?vue&type=style&index=0&id=3768b02f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../@vue-modules/vue/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3768b02f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../@vue-modules/vuetify/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
installComponents(component, {VAlert})
